<template>
  <div id="teaser">
    <header id="header" class="DownMove">
        <div class="header_area">
            <h1 class="logo_area">
                <router-link to="/teaser">
                    TEST中 <img src="@/assets/teaser/img/logo.svg" alt="magarigawaのロゴマーク">
                </router-link>
        </h1>
            <div class="header_right">
                <div class="accordion-area_header sp">
                    <div class="header_btn sp">
                        <div class="btn_boder">
                        <p class="en_txt">MENU</p>
                    </div>
                    </div>
                    <div class="box_header">
                        <ul class="header_btn_li sp">
                            <li>
                              <router-link class="" to="/reservation/drive">コースのご予約</router-link></li>
                            <li>
                              <router-link class="" to="/reservation/lodging">ホテルのご予約</router-link></li>
                        </ul>
                        </div>
                </div>
                <div class="header_btn_pc tb">
                    <ul class="header_btn_li">
                        <li>
                            <div class="btn_boder"><router-link class="" to="/reservation/drive">コースのご予約</router-link></div></li>
                        <li><div class="btn_boder"><router-link class="" to="/reservation/lodging">ホテルのご予約</router-link></div></li>
                    </ul>
                </div>
            </div>
        <div class="news_area sp">
            <p class="news_tag">NEWS</p>
            <div class="news_ticker">
        <ul class="news_slider">
            <li><router-link class="jp_txt" to="/information/34">12月貸切スケジュール</router-link></li>
            <li><router-link class="jp_txt" to="/information/49">1・2月限定宿泊プラン</router-link></li>
            <li><router-link class="jp_txt" to="/information/36">オーナーズガレージ契約者様募集</router-link></li>
            <li><router-link class="jp_txt" to="/information/30">バーゲート入場方法</router-link></li>
            </ul>
        </div>
        </div>
        </div>

    </header>
    <section id="top">
        <div class="main_v">
            <div class="slick">
                <div class="slick__bg slick__bg01"></div>
                <div class="slick__bg slick__bg02"></div>
                <div class="slick__bg slick__bg03"></div>
            </div>
            <div class="news_area pc">
                <p class="news_tag">NEWS</p>
                <div class="news_ticker">
            <ul class="news_slider">
                <li><router-link class="jp_txt" to="/information/34">12月貸切スケジュール</router-link></li>
                <li><router-link class="jp_txt" to="/information/49">1・2月限定宿泊プラン</router-link></li>
                <li><router-link class="jp_txt" to="/information/36">オーナーズガレージ契約者様募集</router-link></li>
                <li><router-link class="jp_txt" to="/information/30">バーゲート入場方法</router-link></li>
                

                </ul>
            </div>
            </div>
        </div>


    </section>
    <footer>
        <div class="footer_top_area jp_txt">
            <div class="footer_left accordion-area">
                <div class="footer_guid">
                    <p class="title">ガイドブック</p>
<div class="box">
    <ul class="footer_li">
        <li><a href="shr/pdf/ご利用にあたってのコピー.pdf" target="_blank">メンバーズガイド</a></li>
        <li><a href="shr/pdf/施設利用ガイド_jp.pdf" target="_blank">ファシリティガイド</a></li>
    </ul>
</div>
                </div>
                <div class="footer_info">
                    <p class="title">インフォメーション</p>
                    <div class="box">
                    <ul class="footer_li">
                        <li><a href="shr/pdf/走行スケジュール_jp.pdf" target="_blank">走行スケジュール</a></li>
                        <li><a href="https://www1.ms-event.net/mgcweb/mgwapp/information/49" target="_blank">宿泊プラン</a></li>
                        <li><a href="https://www1.ms-event.net/mgcweb/mgwapp/information/list" target="_blank">イベントスケジュール</a></li>
                        <li><a href="shr/pdf/ガレージ4.pdf" target="_blank">オーナーズガレージ</a></li>
                    </ul>
                    </div>
                </div>
                <div class="footer_news">
                    <p class="title">ニュース</p>
                    <div class="box">
                        <ul class="footer_li">
                            <li><a class="jp_txt" href="https://www1.ms-event.net/mgcweb/mgwapp/information/49" target="_blank">1・2月限定宿泊プラン</a></li>
                            <li><a class="jp_txt" href="https://www1.ms-event.net/mgcweb/mgwapp/information/34" target="_blank">12月貸切スケジュール</a></li>
                            <li><a class="jp_txt" href="https://www1.ms-event.net/mgcweb/mgwapp/information/36" target="_blank">オーナーズガレージ契約者様募集</a></li>
                            <li><a class="jp_txt" href="https://www1.ms-event.net/mgcweb/mgwapp/information/30" target="_blank">バーゲート入場方法</a></li>

                        </ul>
                    </div>
                </div>
                <div class="footer_contact">
                    <a href="https://www1.ms-event.net/mgcweb/mgwapp/inquiry/index" target="_blank">
                    <p>お問い合わせ</p>
                </a>
                </div>
            </div>
            <div class="footer_right">
                <ul>
                    <li><a href="https://www.facebook.com/TheMagarigawaClub" target="_blank"><img src="@/assets/teaser/img/ico_facebook.svg" alt="facebook"></a></li>
                    <li><a href="https://www.instagram.com/themagarigawaclub/" target="_blank"><img src="@/assets/teaser/img/ico_instagram.svg" alt="instagram"></a></li>
                    <li><a href="https://www.youtube.com/channel/UCW9tjzJo15aB68qGMWHtW8Q" target="_blank"><img src="@/assets/teaser/img/ico_youtube.svg" alt="youtube"></a></li>
                    <li><a href="https://www.linkedin.com/company/magarigawa/"><img src="@/assets/teaser/img/ico_linkedin.svg" alt="linkedin" target="_blank"></a></li>
                </ul>
            </div>
        </div>
        <div class="footer_bottom_area">
            <div class="footer_pri">
                <p class="jp_copy">THE MAGARIGAWA CLUB</p>
                <p class="jp_copy">お問い合わせ窓口: TEL <a href="tel:047-029-3590">047-029-3590 </a></p>
                <p class="jp_copy"><a href="https://www1.ms-event.net/mgcweb/mgwapp/user/policy" target="_blank">PRIVACY POLICY</a></p>
            </div>
            <div class="footer_copy jp_copy">© THE MAGARIGAWA CLUB</div>
        </div>
    </footer>
    <div id="jquery"></div>
  </div>
</template>
<style scoped>
</style>
<script>
// import { mapState } from 'vuex'
// import "../../assets/teaser/js/jquery.min.js"
// import "../../assets/teaser/js/slick.min.js"
// import "../../assets/teaser/js/jquery.bxslider.min.js"
// import "../../assets/teaser/js/comon.js"
// import jQuery from 'jquery'
// global.jquery = jQuery
// global.$ = jQuery
// window.$ = window.jQuery = require('jquery')
// import postscribe from 'postscribe'

export default {
    name: 'teaser',
    data: function(){
        return {
            //   count: this.$store.state.count
        }
    },
    computed:{
        // ...mapState(['count']),
    },
    components: {
    },
    created () {
    },
    methods:{
    },
    mounted (){
        // postscribe('#jquery', '');
    }
}
</script>
<style src="../../assets/teaser/css/slick.css" scoped></style>
<style src="../../assets/teaser/css/comon.css" scoped></style>
<style src="../../assets/teaser/css/style.css" scoped></style>
<!-- <style scoped>
@import "../../assets/teaser/css/slick.css";
@import "../../assets/teaser/css/comon.css";
@import "../../assets/teaser/css/style.css";

</style> -->